<template>
	<v-card class="shadowCard">
	  <v-card-title primary-title>
	  	<v-spacer></v-spacer>
	    <span class="text-body-1 text-center white--text"><strong>¿Qué te pareció la clase del día de hoy?</strong></span>
	  	<v-spacer></v-spacer>
	  </v-card-title>
	  <v-card-text>
      <ul class="feedback" style="text-align: center; align-content: center; align-items: center; justify-content: center; justify-items: center;">
        <li :class="`angry ${ seleccion == 1 ? 'active' : '' }`" @click="seleccion = 1">
          <div>
            <svg class="eye left">
              <use xlink:href="#eye"></use>
            </svg>
            <svg class="eye right">
              <use xlink:href="#eye"></use>
            </svg>
            <svg class="mouth">
              <use xlink:href="#mouth"></use>
            </svg>
          </div>
        </li>
        <li :class="`sad ${ seleccion == 2 ? 'active' : '' }`" @click="seleccion = 2">
          <div>
            <svg class="eye left">
              <use xlink:href="#eye"></use>
            </svg>
            <svg class="eye right">
              <use xlink:href="#eye"></use>
            </svg>
            <svg class="mouth">
              <use xlink:href="#mouth"></use>
            </svg>
          </div>
        </li>

        <li :class="`ok ${ seleccion == 3 ? 'active' : '' }`" @click="seleccion = 3">
          <div></div>
        </li>

        <li :class="`good ${ seleccion == 4 ? 'active' : '' }`" @click="seleccion = 4">
          <div>
            <svg class="eye left">
              <use xlink:href="#eye"></use>
            </svg>
            <svg class="eye right">
              <use xlink:href="#eye"></use>
            </svg>
            <svg class="mouth">
              <use xlink:href="#mouth"></use>
            </svg>
          </div>
        </li>
        <li :class="`happy ${ seleccion == 5 ? 'active' : '' }`" @click="seleccion = 5">
          <div>
            <svg class="eye left">
              <use xlink:href="#eye"></use>
            </svg>
            <svg class="eye right">
              <use xlink:href="#eye"></use>
            </svg>
          </div>
        </li>
      </ul>
      
      <svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 4" id="eye">
          <path d="M1,1 C1.83333333,2.16666667 2.66666667,2.75 3.5,2.75 C4.33333333,2.75 5.16666667,2.16666667 6,1"></path>
        </symbol>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 7" id="mouth">
          <path d="M1,5.5 C3.66666667,2.5 6.33333333,1 9,1 C11.6666667,1 14.3333333,2.5 17,5.5"></path>
        </symbol>
      </svg>
	  </v-card-text>
	  <v-card-actions>
	    <v-spacer></v-spacer>
      <v-btn class="text-capitalize primary--text" rounded large block color="white" @click="enviarRespuestaValoracion()">Enviar</v-btn>
	  </v-card-actions>
	</v-card>
</template>

<script>
	// Importar lebrerías
	import { mapGetters, mapActions } from 'vuex'
  const  base64 = require('base-64');

	// Componentes
  import Alerta     from '@/components/alertas/Alerta.vue'
  import Loader     from '@/components/alertas/Loader.vue'

  export default {
  	components:{
  		Alerta,
      Loader,
  	},

  	props:[
			'encuesta'
	  ],

    data () {
      return {
      	seleccion: 5
      }
    },

    created ( ) {
    	
    },

    computed:{
      ...mapGetters( 'login', [ 'getGrupo', 'getUsuarioLMS', 'getGrupos', 'getEscuela' ]),
    },

    async created ( ){

    },

    methods:{
    	...mapActions( 'login', [ 'abrirGrupo', 'grabarGruposUsuario', 'salirLogin' ]),

    	enviarRespuestaValoracion ( ){
    		const payload = {
    			id_usuario: this.getUsuarioLMS.id,
    			valoracion: this.seleccion
    		}
        // Hacemos la petición
        this.$http.post('enviar.evaluacion', payload).then( response => {
          this.encuesta.visible = false
          // Guardamos los grupos
        }).catch( error =>{
          if( error.status == 400 || error.status == 500){
	          this.parametros.mensaje      = error.body.message
	          this.parametros.dialogError  = true 
	          this.parametros.color        = '#FF2C2C'
	          this.respuestaAlerta = true 
	        }
        }).finally(()=>{ this.cargar = false })

    		
    	}
    }
  }
</script>

<style scoped>

	.shadowCard{
		border-radius: 15px !important; 
		box-shadow: 0 20px 27px 0 rgba(0,0,0,0.2)  !important;
		background: rgb(59,137,199);
		background: linear-gradient(90deg, rgba(59,137,199,1) 0%, rgba(0,53,194,1) 100%);
	}

  .feedback {
    --normal: #ECEAF3;
    --normal-shadow: #D9D8E3;
    --normal-mouth: #9795A4;
    --normal-eye: #595861;
    --active: #F8DA69;
    --active-shadow: #F4B555;
    --active-mouth: #F05136;
    --active-eye: #313036;
    --active-tear: #76b5e7;
    --active-shadow-angry: #e94f1d;
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
  }
  .feedback li {
    position: relative;
    border-radius: 50%;
    background: var(--sb, var(--normal));
    box-shadow: inset 3px -3px 4px var(--sh, var(--normal-shadow));
    transition: background 0.4s, box-shadow 0.4s, transform 0.3s;
    -webkit-tap-highlight-color: transparent;
  }
  .feedback li:not(:last-child) {
    margin-right: 20px;
  }
  .feedback li div {
    width: 40px;
    height: 40px;
    position: relative;
    transform: perspective(240px) translateZ(4px);
  }
  .feedback li div svg, .feedback li div:before, .feedback li div:after {
    display: block;
    position: absolute;
    left: var(--l, 9px);
    top: var(--t, 13px);
    width: var(--w, 8px);
    height: var(--h, 2px);
    transform: rotate(var(--r, 0deg)) scale(var(--sc, 1)) translateZ(0);
  }
  .feedback li div svg {
    fill: none;
    stroke: var(--s);
    stroke-width: 2px;
    stroke-linecap: round;
    stroke-linejoin: round;
    transition: stroke 0.4s;
  }
  .feedback li div svg.eye {
    --s: var(--e, var(--normal-eye));
    --t: 17px;
    --w: 7px;
    --h: 4px;
  }
  .feedback li div svg.eye.right {
    --l: 23px;
  }
  .feedback li div svg.mouth {
    --s: var(--m, var(--normal-mouth));
    --l: 11px;
    --t: 23px;
    --w: 18px;
    --h: 7px;
  }
  .feedback li div:before, .feedback li div:after {
    content: "";
    z-index: var(--zi, 1);
    border-radius: var(--br, 1px);
    background: var(--b, var(--e, var(--normal-eye)));
    transition: background 0.4s;
  }
  .feedback li.angry {
    --step-1-rx: -24deg;
    --step-1-ry: 20deg;
    --step-2-rx: -24deg;
    --step-2-ry: -20deg;
  }
  .feedback li.angry div:before {
    --r: 20deg;
  }
  .feedback li.angry div:after {
    --l: 23px;
    --r: -20deg;
  }
  .feedback li.angry div svg.eye {
    stroke-dasharray: 4.55;
    stroke-dashoffset: 8.15;
  }
  .feedback li.angry.active {
    -webkit-animation: angry 1s linear;
            animation: angry 1s linear;
  }
  .feedback li.angry.active div:before {
    --middle-y: -2px;
    --middle-r: 22deg;
    -webkit-animation: toggle 0.8s linear forwards;
            animation: toggle 0.8s linear forwards;
  }
  .feedback li.angry.active div:after {
    --middle-y: 1px;
    --middle-r: -18deg;
    -webkit-animation: toggle 0.8s linear forwards;
            animation: toggle 0.8s linear forwards;
  }
  .feedback li.sad {
    --step-1-rx: 20deg;
    --step-1-ry: -12deg;
    --step-2-rx: -18deg;
    --step-2-ry: 14deg;
  }
  .feedback li.sad div:before, .feedback li.sad div:after {
    --b: var(--active-tear);
    --sc: 0;
    --w: 5px;
    --h: 5px;
    --t: 15px;
    --br: 50%;
  }
  .feedback li.sad div:after {
    --l: 25px;
  }
  .feedback li.sad div svg.eye {
    --t: 16px;
  }
  .feedback li.sad div svg.mouth {
    --t: 24px;
    stroke-dasharray: 9.5;
    stroke-dashoffset: 33.25;
  }
  .feedback li.sad.active div:before, .feedback li.sad.active div:after {
    -webkit-animation: tear 0.6s linear forwards;
            animation: tear 0.6s linear forwards;
  }
  .feedback li.ok {
    --step-1-rx: 4deg;
    --step-1-ry: -22deg;
    --step-1-rz: 6deg;
    --step-2-rx: 4deg;
    --step-2-ry: 22deg;
    --step-2-rz: -6deg;
  }
  .feedback li.ok div:before {
    --l: 12px;
    --t: 17px;
    --h: 4px;
    --w: 4px;
    --br: 50%;
    box-shadow: 12px 0 0 var(--e, var(--normal-eye));
  }
  .feedback li.ok div:after {
    --l: 13px;
    --t: 26px;
    --w: 14px;
    --h: 2px;
    --br: 1px;
    --b: var(--m, var(--normal-mouth));
  }
  .feedback li.ok.active div:before {
    --middle-s-y: .35;
    -webkit-animation: toggle 0.2s linear forwards;
            animation: toggle 0.2s linear forwards;
  }
  .feedback li.ok.active div:after {
    --middle-s-x: .5;
    -webkit-animation: toggle 0.7s linear forwards;
            animation: toggle 0.7s linear forwards;
  }
  .feedback li.good {
    --step-1-rx: -14deg;
    --step-1-rz: 10deg;
    --step-2-rx: 10deg;
    --step-2-rz: -8deg;
  }
  .feedback li.good div:before {
    --b: var(--m, var(--normal-mouth));
    --w: 5px;
    --h: 5px;
    --br: 50%;
    --t: 22px;
    --zi: 0;
    opacity: 0.5;
    box-shadow: 16px 0 0 var(--b);
    filter: blur(2px);
  }
  .feedback li.good div:after {
    --sc: 0;
  }
  .feedback li.good div svg.eye {
    --t: 15px;
    --sc: -1;
    stroke-dasharray: 4.55;
    stroke-dashoffset: 8.15;
  }
  .feedback li.good div svg.mouth {
    --t: 22px;
    --sc: -1;
    stroke-dasharray: 13.3;
    stroke-dashoffset: 23.75;
  }
  .feedback li.good.active div svg.mouth {
    --middle-y: 1px;
    --middle-s: -1;
    -webkit-animation: toggle 0.8s linear forwards;
            animation: toggle 0.8s linear forwards;
  }
  .feedback li.happy div {
    --step-1-rx: 18deg;
    --step-1-ry: 24deg;
    --step-2-rx: 18deg;
    --step-2-ry: -24deg;
  }
  .feedback li.happy div:before {
    --sc: 0;
  }
  .feedback li.happy div:after {
    --b: var(--m, var(--normal-mouth));
    --l: 11px;
    --t: 23px;
    --w: 18px;
    --h: 8px;
    --br: 0 0 8px 8px;
  }
  .feedback li.happy div svg.eye {
    --t: 14px;
    --sc: -1;
  }
  .feedback li.happy.active div:after {
    --middle-s-x: .95;
    --middle-s-y: .75;
    -webkit-animation: toggle 0.8s linear forwards;
            animation: toggle 0.8s linear forwards;
  }

  .feedback li:not(.active) {
    cursor: pointer;
  }

  .feedback li:not(.active):active {
    transform: scale(0.925);
  }
  .feedback li.active {
    --sb: var(--active);
    --sh: var(--active-shadow);
    --m: var(--active-mouth);
    --e: var(--active-eye);
  }
  .feedback li.active div {
    -webkit-animation: shake 0.8s linear forwards;
            animation: shake 0.8s linear forwards;
  }

  @keyframes shake {
    30% {
      transform: perspective(240px) rotateX(var(--step-1-rx, 0deg)) rotateY(var(--step-1-ry, 0deg)) rotateZ(var(--step-1-rz, 0deg)) translateZ(10px);
    }
    60% {
      transform: perspective(240px) rotateX(var(--step-2-rx, 0deg)) rotateY(var(--step-2-ry, 0deg)) rotateZ(var(--step-2-rz, 0deg)) translateZ(10px);
    }
    100% {
      transform: perspective(240px) translateZ(4px);
    }
  }
  @-webkit-keyframes tear {
    0% {
      opacity: 0;
      transform: translateY(-2px) scale(0) translateZ(0);
    }
    50% {
      transform: translateY(12px) scale(0.6, 1.2) translateZ(0);
    }
    20%, 80% {
      opacity: 1;
    }
    100% {
      opacity: 0;
      transform: translateY(24px) translateX(4px) rotateZ(-30deg) scale(0.7, 1.1) translateZ(0);
    }
  }
  @keyframes tear {
    0% {
      opacity: 0;
      transform: translateY(-2px) scale(0) translateZ(0);
    }
    50% {
      transform: translateY(12px) scale(0.6, 1.2) translateZ(0);
    }
    20%, 80% {
      opacity: 1;
    }
    100% {
      opacity: 0;
      transform: translateY(24px) translateX(4px) rotateZ(-30deg) scale(0.7, 1.1) translateZ(0);
    }
  }
  @-webkit-keyframes toggle {
    50% {
      transform: translateY(var(--middle-y, 0)) scale(var(--middle-s-x, var(--middle-s, 1)), var(--middle-s-y, var(--middle-s, 1))) rotate(var(--middle-r, 0deg));
    }
  }
  @keyframes toggle {
    50% {
      transform: translateY(var(--middle-y, 0)) scale(var(--middle-s-x, var(--middle-s, 1)), var(--middle-s-y, var(--middle-s, 1))) rotate(var(--middle-r, 0deg));
    }
  }
  @-webkit-keyframes angry {
    40% {
      background: var(--active);
    }
    45% {
      box-shadow: inset 3px -3px 4px var(--active-shadow), inset 0 8px 10px var(--active-shadow-angry);
    }
  }
  @keyframes angry {
    40% {
      background: var(--active);
    }
    45% {
      box-shadow: inset 3px -3px 4px var(--active-shadow), inset 0 8px 10px var(--active-shadow-angry);
    }
  }

  html {
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
  }

  * {
    box-sizing: inherit;
  }
  *:before, *:after {
    box-sizing: inherit;
  }

  #modalCokie {
    z-index: 1;
    position: fixed;
    top: 0px;
    left: 0px;
    overflow-x: hidden;
    display: block;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -ms-flex-pack: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    opacity: 0;
    transition: opacity 250000ms 700000ms;
    overflow-x: hidden;
    background-color: rgba(31,32,41,.75);
    align-items: center;
  }

  .encuesta2 {
    z-index: 1;
    position: fixed;
    top: 0px;
    left: 0px;
    overflow-x: hidden;
    display: block;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -ms-flex-pack: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    opacity: 0;
    transition: opacity 250000ms 700000ms;
    overflow-x: hidden;
    background-color: rgba(31,32,41,.75);
    align-items: center;
  }

  .cookiesContent {
    justify-content: center;
    align-items: center;
    vertical-align: middle;
    max-width: 600px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #fff;
    color: #000;
    text-align: center;
    border-radius: 20px;
    padding: 30px 30px 70px;
  }

  .cookiesContent button.close {
    width: 30px;
    font-size: 20px;
    color: #c0c5cb;
    align-self: flex-end;
    background-color: transparent;
    border: none;
    margin-bottom: 10px;
  }

  .cookiesContent img {
    width: 250px;
    margin-bottom: 15px;
  }

  .cookiesContent p {
    margin-bottom: 40px;
    font-size: 18px;
  }

  .cookiesContent button.accept {
    background-color: #ed6755;
    border: none;
    border-radius: 5px;
    width: 200px;
    padding: 14px;
    font-size: 16px;
    color: white;
    box-shadow: 0px 6px 18px -5px #ed6755;
  }

  @media only screen and (max-width: 1026px) {
      #fadeshow1 {
          display: none;
      }
  }

  #page-top {
    padding-right: 0px;
  }

  .progress {
    width: 150px;
    height: 150px;
    background: none;
    position: relative;
  }

  .progress::after {
    content: "";
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 22px solid #eee;
    position: absolute;
    top: 0;
    left: 0;
  }

  .progress>span {
    width: 50%;
    height: 100%;
    overflow: hidden;
    position: absolute;
    top: 0;
    z-index: 1;
  }

  .progress .progress-left {
    left: 0;
  }

  .progress .progress-bar {
    width: 100%;
    height: 100%;
    background: none;
    border-width: 22px;
    border-style: solid;
    position: absolute;
    top: 0;
  }

  .progress .progress-left .progress-bar {
    left: 100%;
    border-top-right-radius: 80px;
    border-bottom-right-radius: 80px;
    border-left: 0;
    -webkit-transform-origin: center left;
    transform-origin: center left;
  }

  .progress .progress-right {
    right: 0;
  }

  .progress .progress-right .progress-bar {
    left: -100%;
    border-top-left-radius: 80px;
    border-bottom-left-radius: 80px;
    border-right: 0;
    -webkit-transform-origin: center right;
    transform-origin: center right;
  }

  .progress .progress-value {
    position: absolute;
    top: 0;
    left: 0;
  }

  /*******************************************************************/
  #card-grupo {
    background: rgb(0, 0, 99);
    background: linear-gradient(90deg, rgba(0, 0, 99, 0.8519782913165266) 9%, rgba(9, 75, 121, 0.8407738095238095) 44%, rgba(185, 242, 255, 1) 100%);
    color: #FFF !important;
  }

  /******************************************************************/
  #chartdiv {
    width: 100%;
    height: 130px;
  }

  /*
  *
  * ==========================================
  * FOR DEMO PURPOSE
  * ==========================================
  *
  */

  body {
    background: #ff7e5f;
    background: -webkit-linear-gradient(to right, #ff7e5f, #feb47b);
    background: linear-gradient(to right, #ff7e5f, #feb47b);
    min-height: 100vh;
    padding-right: 0px !important;
  }

  .rounded-lg {
    border-radius: 1rem;
  }

  .text-gray {
    color: #aaa;
  }

  div.h4 {
    line-height: 1rem;
  }

  .scroll {
    overflow-y: hidden;
  }
</style>